import { FormFieldCombobox as ChordsFormFieldCombobox } from '~/chords/FormField';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const FormFieldCombobox = withClassNameHoc(ChordsFormFieldCombobox);
